import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GlobalDbnTaxonomyDomainComponent from '../components/global-dbn-taxonomy-domain.component';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { selectGlobalDbnTaxonomyDomainsListItems, selectGlobalDbnTaxonomyDomainsQueryItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';
import { globalDbnTaxonomyDomains } from '../../../../redux/global-dbn-taxonomy-domains/action';
import PageLoader from '../../../../components/PageLoader';
import { settings } from '../../../../redux/settings/actions';
import { selectCurrent } from '../../../../redux/settings/selectors';

const GlobalDbnTaxonomyDomain = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  
  const queryItems = useSelector(selectGlobalDbnTaxonomyDomainsQueryItems)
  const domainItems = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [templateFiles, setTemplatesFiles] = useState<any>([])
  const [selectedTemplate, setSelectedTemplate] = useState<any>({})
  
  const [selectedDomain, setSelectedDomain] = useState<any>({
    Code: '',
    IsSubDomain: false,
    Name: '',
    ParentDomainId: null,
    EntityAttributes: [],
    MediaMappings: {},

  })
  const [entityAttributes, setEntityAttributes] = useState<any>([]);

  const parentDomain = domainItems?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubDomain === false
  )

  const fetchGlobalDbnTaxonomyDomainById = () => {
    dispatch(globalDbnTaxonomyDomains.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch-detail`, entity: 'globalDbnTaxonomyDomains', jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDomain({ ...selectedDomain, [field]: event });
  }

  const handleImageChange = ({ field, value }: { field: string; value: any }) => {
    setSelectedDomain((prev: any) => {
      const updated = { ...prev };
  
      // Support nested paths like DisplayOption.ShowOnCart
      const keys = field.split('.');
      let current = updated;
  
      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        current[key] = current[key] ?? {}; // create if not exist
        current = current[key];
      }
  
      current[keys[keys.length - 1]] = value;
  
      return updated;
    });
  };

    const handleFormTemplateItemChange: any = (event: any, field: string) => {
      setTemplatesFiles({ ...selectedDomain, [field]: event });
    }
  

  useEffect(() => {
    dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'delete' })).then(() => {
      dispatch(globalDbnTaxonomyDomains.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
        entity: 'globalDbnTaxonomyDomains',
        jsonData:
        {
          "Context": {},
          "Records": [
            {
              "IsSubDomain": false
            }
          ],
          "Pagination": {
            // "PageNumber": pageData,
            // "PageSize": pageSize,
            "SortField": "DBNDomainId",
            "SortOrder": "desc",
            // "Searches": searchCriteria,
          }
        }
      })).then(() => {
        if (parmas?.id > 0) {
          fetchGlobalDbnTaxonomyDomainById()
          setIsLoading(false)
        }
        else {
          setIsLoading(false)
        }
      })
    })
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedDomain(queryItems?.result?.items)
      const selectedEntityAttributes = queryItems?.result?.items?.EntityAttributes?.map((item: any) => {
        const attributes = {
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          ValueItem1Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Type || '',
          ValueItem1Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Value || '',
          ValueItem1IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1
              ?.IsSelected || false,
          ValueItem2Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Type || '',
          ValueItem2Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Value || '',
          ValueItem2IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2
              ?.IsSelected || false,
          ValueItem3Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Type || '',
          ValueItem3Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Value || '',
          ValueItem3IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3
              ?.IsSelected || false,
          ValueItem4Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Type || '',
          ValueItem4Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Value || '',
          ValueItem4IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4
              ?.IsSelected || false,
          ValueItem5Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Type || '',
          ValueItem5Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Value || '',
          ValueItem5IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5
              ?.IsSelected || false,
          TextValue:
            item?.EntityAttributeValue?.SingleControlType?.TextValue || '',
          NumberValue:
            item?.EntityAttributeValue?.SingleControlType?.NumberValue || 0,
          DateValue:
            item?.EntityAttributeValue?.SingleControlType?.DateValue || '',
          FileTypeId:
            item?.EntityAttributeValue?.SingleControlType?.FileTypeId || 0,
          FileMappingUrl:
            item?.EntityAttributeValue?.SingleControlType?.FileMappingUrl || '',
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: item?.OwnerId || 0,
        };
        return attributes;
      });
      setEntityAttributes(selectedEntityAttributes);
    }
  }, [isQuery])

  useEffect(() => {
    
  }, []);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    let mediaFiles = selectedDomain.MediaMappings?.MediaFiles || []
        mediaFiles.splice(
          mediaFiles.length - 1,
          1
        )        
    
    if (parmas?.id > 0) {

      entityAttributes?.splice(entityAttributes.length - 1, 1);
      const selectedEntityAttributes: any = entityAttributes?.map((item: any) => {
        const attributes: any = {
          Id: item?.Id,
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          EntityAttributeValue: {
            MultiControlType: {
              ValueItem1: {
                Type: item?.ValueItem1Type || 'string',
                Value: item?.ValueItem1Value || 'string',
                IsSelected: item?.ValueItem1IsSelected || false,
              },
              ValueItem2: {
                Type: item?.ValueItem2Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem2IsSelected || false,
              },
              ValueItem3: {
                Type: item?.ValueItem3Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem3IsSelected || false,
              },
              ValueItem4: {
                Type: item?.ValueItem4Type || 'string',
                Value: item?.ValueItem4Value || 'string',
                IsSelected: item?.ValueItem4IsSelected || false,
              },
              ValueItem5: {
                Type: item?.ValueItem5Type || 'string',
                Value: item?.ValueItem5Value || 'string',
                IsSelected: item?.ValueItem5IsSelected || false,
              },
            },
            SingleControlType: {
              TextValue: item?.TextValue || 'string',
              NumberValue: item?.NumberValue || 0,
              DateValue: item?.DateValue || '2024-05-22T04:52:47.083',
              FileTypeId: item?.FileTypeId || 0,
              FileMappingUrl: item?.FileMappingUrl || 'string',
            },
          },
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: Number(parmas?.id) || 0,
        };
        return attributes;
      });
      const domainData = {
        Code: selectedDomain?.Code,
        IsSubDomain: selectedDomain?.IsSubDomain,
        Name: selectedDomain?.Name,
        EntityAttributes: selectedEntityAttributes,
        Id: selectedDomain?.GlobalDBNDomainId,
        ParentDomainId: selectedDomain?.ParentDomainId,
        MediaMappings: {
          MediaFiles: mediaFiles,
          Templates: [selectedTemplate]
      }
    }

      await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'update' }))
      await dispatch(globalDbnTaxonomyDomains.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains`,
        entity: 'globalDbnTaxonomyDomains',
        jsonData:
        {
          Context: {},
          Records: [domainData]
        }
      })).then(() => {
        back()
      })
    } else {
      const domainData = {
        Code: selectedDomain?.Code,
        IsSubDomain: selectedDomain?.IsSubDomain,
        Name: selectedDomain?.Name,
        Id: selectedDomain?.GlobalDBNDomainId,
        ParentDomainId: selectedDomain?.ParentDomainId,
        MediaMappings: {
          MediaFiles: mediaFiles,
          Templates: [selectedTemplate]
        },

      }

      await dispatch(globalDbnTaxonomyDomains.resetAction({ actionType: 'create' }))
      await dispatch(globalDbnTaxonomyDomains.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains`,
        entity: 'globalDbnTaxonomyDomains',
        jsonData:
        {
          Context: {},
          Records: [domainData]

        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/dbn/domains')
  }

  
    // const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    //   const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    //   const newsSelectedMedia = {
    //     Id: 0,
    //     FileTypeId: 0,
    //     OwnerTypeId: 174,
    //     FileMappingURL: ''
    //   }
    //   if (localSelectedmedia.length === 0 ||
    //     localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    //   ) {
    //     localSelectedmedia?.push(newsSelectedMedia)
    //   }
    //   return localSelectedmedia
    // }
  
    // const setCombinationInfo = async () => {
    //   let localSelectedMedia = deepCopy(mediaFiles)
    //   localSelectedMedia.splice(
    //     currentChange.idx,
    //     1,
    //     { ...localSelectedMedia[currentChange.idx] }
    //   );
    //   localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    //   currentChange.field = 'FileTypeIdDONE'
    //   setMediaFiles(localSelectedMedia)
    // }
  
    // const changeImage = (idx: number, templateField: any, fileType: any) => {
    //   setCategoryImageIndex(idx)
    //   dispatch(settings.set({ getUploadFiles: 'open' }))
    //   setOpenFile({
    //     currentFileSrc: mediaFiles[idx][templateField],
    //     folder: 'Category',
    //     type: fileType
    //   })
    // }
  
    
    // const handleSubmit = (data: any) => {
    //   mediaFiles[categoryImageIndex].FileMappingURL = data
    //   const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    //   setMediaFiles(localSelectedMedia)
    // }
  
    const handleClose = () => {
      dispatch(settings.set({ getUploadFiles: 'close' }))
    }
  
    // useEffect(() => {
    //   if (currentChange.field === 'FileTypeId') {
    //     setCombinationInfo()
    //   }
    // }, [mediaFiles])

  return (
    <>
    {/* {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
            folder={openFile?.folder}
            handleClose={handleClose}
            handleFilesSubmit={handleSubmit}
            type={openFile?.type}
            ownerId={parmas?.id}
          />} */}
      {isLoading ? <PageLoader /> :
        <GlobalDbnTaxonomyDomainComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedDomain={selectedDomain}
          parentDomain={parentDomain}
          back={back}
          handleFormSubmit={handleFormSubmit}
          entityAttributes={entityAttributes}
          setEntityAttributes={setEntityAttributes}
          id={parmas?.id}
        //  functionAttributes={functionAttributes}
        //  setFunctionAttributes={setFunctionAttributes}
          // handleFormItemChange={handleFormItemChange}
          handleFormAttachmentItemChange={handleFormTemplateItemChange}
          mediaFiles={selectedDomain?.MediaMappings?.MediaFiles}
          // changeImage={changeImage}
          templateFiles={templateFiles}
          selectedTemplate={selectedTemplate}
          // handleFormTemplateItemChange={handleFormTemplateItemChange}
          handleImageChange={handleImageChange}
        />
      }
    </>
  )
}

export default GlobalDbnTaxonomyDomain;
